import axios from 'axios'
import store from '../../store/index'

const reconnectFeed = function () {
  function isFunction(functionToCheck) {
    return (
      functionToCheck &&
      {}.toString.call(functionToCheck) === '[object Function]'
    )
  }
  const callback = function () {
    this.connection()
    // Double every attempt to avoid overwhelming server
    reconnectFrequencySeconds *= 2
    // Max out at ~1 minute as a compromise between user experience and server load
    if (reconnectFrequencySeconds >= 32) {
      reconnectFrequencySeconds = 32
    }
  }
  const delay = function () {
    return reconnectFrequencySeconds * 1000
  }
  function debounce(func, wait) {
    let timeout
    let waitFunc
    return function () {
      if (isFunction(wait)) {
        waitFunc = wait
      } else {
        waitFunc = function () {
          return wait
        }
      }
      let context = this,
        args = arguments
      let later = function () {
        timeout = null
        func.apply(context, args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, waitFunc())
    }
  }
  debounce(callback, delay)
}

// storing SSE connection in global scope to make possible menaging the connection
let evtSource

// reconnectFrequencySeconds doubles every retry
let reconnectFrequencySeconds = 1

export default {
  getLastSnapshot: async function (symbol) {
    // const urlSnapshot = process.env.VUE_APP_FEEDEVENT_URL+'Quote,Summary,Trade&symbols='+symbol+"&indent"
    const urlSnapshot =
      process.env.VUE_APP_FEEDEVENT_DEMO_URL +
      'Quote,Summary,Trade,Greeks,TheoPrice&symbols=' +
      symbol +
      '&indent'
    console.log('getLastSnapshot url \n', urlSnapshot)
    try {
      const response = await axios({
        method: 'get',
        url: urlSnapshot,
      })
      console.log('getLastSnapshot response', response.data)
      store.commit('setInitialOptionChain', response.data)
    } catch (error) {
      console.error('Error massage from getLastSnapshot:', error.message)
    }
  },
  getTrade: async function (symbol) {
    console.log('getTrade symbol \n', symbol)
    try {
      const response = await axios({
        method: 'get',
        // url: process.env.VUE_APP_FEEDEVENT_URL+'Trade&symbols='+symbol+'&indent'
        url:
          process.env.VUE_APP_FEEDEVENT_DEMO_URL +
          'Trade&symbols=' +
          symbol +
          '&indent',
      })
      console.log('getTrade response \n', response.data)
      // store.commit('setOptionChain', liveData)
      return response.data.Trade[symbol].price
    } catch (error) {
      console.error('Error massage from getTrade:', error.message)
    }
  },
  optionChainSubscribe: async function (symbol) {
    // const urlBase = process.env.VUE_APP_FEEDEVENTSOURCE_URL+'Quote,Summary,Trade&symbols='+symbol
    const urlBase =
      process.env.VUE_APP_FEEDEVENTSOURCE_DEMO_URL +
      'Quote,Summary,Trade&symbols=' +
      symbol
    if (!evtSource) {
      evtSource = new EventSource(urlBase)
      console.log('optionChainSubscribe \n', evtSource, '\n', urlBase)
    } else {
      evtSource.close()
      evtSource = new EventSource(urlBase)
      console.log('optionChainSubscribe \n', evtSource, '\n', urlBase)
    }
    evtSource.onopen = function (e) {
      console.log('Event Source', e.type, urlBase)
    }
    evtSource.onmessage = async function (e) {
      let liveData = await JSON.parse(e.data)
      store.commit('setOptionChain', liveData)
    }
    evtSource.οnerrοr = function (err) {
      console.error(err)
      evtSource.close()
      reconnectFeed()
    }
  },
  // optionChainAddSubscription: async function (url){

  // },
  // optionChainRemoveSubscription: async function(url){

  // },
  // selectedStockPriceSubscription: async function (url){

  // }
}
